import { axiosInstance } from './axiosConfig';

export const getFlagValue = ({ flagKey, accountId, defaultValue = false }) =>
  axiosInstance
    .get(`feature_flags/${flagKey}/${accountId}?defaultValue=${defaultValue}`)
    .then((response) => response.data);

export const getFlags = ({ accountId }) =>
  axiosInstance.get(`feature_flags/${accountId}`).then((response) => response.data);
